var _mask, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPmUnidentifiedBlackWhite = function SvgPmUnidentifiedBlackWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "pm-unidentified-black-white_svg__a",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 10a4 4 0 0 1 4-4h26a4 4 0 0 1 4 4v14a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V10Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 23.75a.75.75 0 0 0 0-1.5v1.5Zm-1-1.5a.75.75 0 0 0 0 1.5v-1.5Zm4 0a.75.75 0 0 0 0 1.5v-1.5Zm6 1.5a.75.75 0 0 0 0-1.5v1.5ZM1 11.25a.75.75 0 0 0 0 1.5v-1.5Zm32 1.5a.75.75 0 0 0 0-1.5v1.5Zm-27 9.5H5v1.5h1v-1.5Zm3 1.5h6v-1.5H9v1.5Zm-8-11h32v-1.5H1v1.5ZM4 7.5h26v-3H4v3ZM32.5 10v14h3V10h-3ZM30 26.5H4v3h26v-3ZM1.5 24V10h-3v14h3ZM4 26.5A2.5 2.5 0 0 1 1.5 24h-3A5.5 5.5 0 0 0 4 29.5v-3ZM32.5 24a2.5 2.5 0 0 1-2.5 2.5v3a5.5 5.5 0 0 0 5.5-5.5h-3ZM30 7.5a2.5 2.5 0 0 1 2.5 2.5h3A5.5 5.5 0 0 0 30 4.5v3Zm-26-3A5.5 5.5 0 0 0-1.5 10h3A2.5 2.5 0 0 1 4 7.5v-3Z",
    fill: "#08031D",
    mask: "url(#pm-unidentified-black-white_svg__a)"
  })));
};
export default SvgPmUnidentifiedBlackWhite;